import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ChangePasswordLayer from "../../../components/Admin/ChangePasswordLayer";
import AdminDirectorLayer from "../../../components/Admin/AdminDirectorLayer";

const AdminDirector = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AdminDirectorLayer />
      </MasterLayout>
    </>
  );
};

export default AdminDirector;